export default class InputGetList
{
  constructor(pageSize, pageNumber, orderBy, propertyName, searchText, visible = true) 
  {
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
    this.orderBy = orderBy;
    this.propertyName = propertyName;
    this.searchText = searchText;
    this.visible = visible
  }    
}